import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static values = { activeTab: { type: String, default: "photos" } }

  connect() {
    // Show the active tab panel by default
    this.showTab(this.activeTabValue)
  }

  selectTab(event) {
    event.preventDefault()
    const tabName = event.target.closest("[data-tab-name]")?.dataset.tabName
    if (tabName) {
      this.showTab(tabName)
    }
  }

  showTab(tabName) {
    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
    })

    // Deactivate all buttons
    this.buttonTargets.forEach(button => {
      button.classList.remove("border-teal-500", "text-teal-600", "dark:text-teal-400")
      button.classList.add("border-transparent", "text-slate-700", "dark:text-slate-300")
    })

    // Show active panel
    const activePanel = this.panelTargets.find(
      panel => panel.dataset.tabsPanelTab === tabName
    )
    if (activePanel) {
      activePanel.classList.remove("hidden")
      activePanel.classList.add("block")
    }

    // Activate button
    const activeButton = this.buttonTargets.find(
      button => button.dataset.tabsButtonTab === tabName
    )
    if (activeButton) {
      activeButton.classList.remove("border-transparent", "text-slate-700", "dark:text-slate-300")
      activeButton.classList.add("border-teal-500", "text-teal-600", "dark:text-teal-400")
    }

    // Update active tab value
    this.activeTabValue = tabName
  }
}
